export const EXT_TO_LANGUAGE: Record<string, string> = {
    ts: "typescript", tsx: "typescript",
    js: "javascript", jsx: "javascript", mjs: "javascript", cjs: "javascript",
    py: "python",
    rs: "rust",
    go: "go",
    java: "java",
    kt: "kotlin",
    cs: "csharp",
    cpp: "cpp", cc: "cpp", cxx: "cpp", c: "c", h: "c", hpp: "cpp",
    rb: "ruby",
    php: "php",
    swift: "swift",
    html: "html", htm: "html",
    css: "css",
    scss: "scss",
    less: "less",
    json: "json", jsonc: "json",
    yaml: "yaml", yml: "yaml",
    toml: "ini",
    xml: "xml",
    sql: "sql",
    sh: "shell", bash: "shell", zsh: "shell",
    md: "markdown",
    puml: "puml", pu: "puml",
    dockerfile: "dockerfile",
    tf: "hcl",
    proto: "protobuf",
    graphql: "graphql", gql: "graphql",
    lua: "lua",
    r: "r",
    scala: "scala",
};

export function getLanguage(path: string): string {
    const filename = path.split("/").pop() ?? "";
    const lower = filename.toLowerCase();
    if (lower === "dockerfile") return "dockerfile";
    const ext = filename.includes(".") ? filename.split(".").pop()!.toLowerCase() : "";
    return EXT_TO_LANGUAGE[ext] ?? "plaintext";
}
